import React, { useEffect, useMemo, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { GpsLocationDto } from '@area-restrita/api-client/model/gpsLocationDto';
import { BuslineScheduleDetailQueryResponse } from '@area-restrita/api-client/model/buslineScheduleDetailQueryResponse';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { lineStringToRoutePath } from '@/utils/lineStringToRoute';

import BuslineMapView from './view';

interface IProps {
  buslineSchedule: BuslineScheduleDetailQueryResponse;
}

const BuslineMap: React.FC<IProps> = ({ buslineSchedule }) => {
  const { session } = useAuthSessionStore();
  const [location, setLocation] = useState<GpsLocationDto | null>(
    buslineSchedule.active ? buslineSchedule.location : null,
  );
  const mapRef = useRef<L.Map>(null);

  // Extrair coordenadas itinerário
  const route = useMemo(
    () => lineStringToRoutePath(buslineSchedule.route),
    [buslineSchedule.route],
  );

  useEffect(() => {
    if (!session || !buslineSchedule.active || !buslineSchedule.prefix) return;

    const socket = io(import.meta.env.VITE_API_URL, {
      extraHeaders: {
        authorization: `Bearer ${session.accessToken}`,
      },
    });

    console.log('Connecting to socket...');

    socket
      .on('vehicle-location', (location) => {
        console.log('Vehicle location received:', location);
        setLocation((prevLocation) => {
          if (prevLocation === null) {
            mapRef.current?.setView(
              { lat: location.lat, lng: location.lng },
              18,
            );
          }

          return location;
        });
      })
      .on('connect', () => {
        console.log('Socket connected:', socket.id);

        socket.emit('join-tracking-room', {
          tenantId: session.organization?.id,
          vehicleId: buslineSchedule.prefix,
        });
      })
      .on('disconnect', () => {
        console.log('Socket disconnected');
      });

    return () => {
      socket.disconnect();
    };
  }, [session, buslineSchedule.active, buslineSchedule.prefix]);

  return (
    <BuslineMapView
      ref={mapRef}
      routeName={`${buslineSchedule.code} - ${buslineSchedule.name}`}
      driverName={buslineSchedule.driver?.fullName ?? undefined}
      location={location}
      route={route}
      active={buslineSchedule.active}
      startAt={buslineSchedule.startAt}
      endAt={buslineSchedule.endAt}
      daysOfWeek={buslineSchedule.daysOfWeek}
      documents={buslineSchedule.documents}
    />
  );
};

export default BuslineMap;
